import { render, staticRenderFns } from "./PmauContaPrompts.vue?vue&type=template&id=1c4adb04&scoped=true&"
import script from "./PmauContaPrompts.vue?vue&type=script&lang=js&"
export * from "./PmauContaPrompts.vue?vue&type=script&lang=js&"
import style0 from "./PmauContaPrompts.vue?vue&type=style&index=0&id=1c4adb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4adb04",
  null
  
)

export default component.exports